export default __webpack_public_path__ + "static/media/fresenius-hemodialysis.0cf7aedf.jpg";